import { render, staticRenderFns } from "./TextBlockModal.vue?vue&type=template&id=2fd130f3&scoped=true"
import script from "./TextBlockModal.vue?vue&type=script&lang=js"
export * from "./TextBlockModal.vue?vue&type=script&lang=js"
import style0 from "./TextBlockModal.vue?vue&type=style&index=0&id=2fd130f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd130f3",
  null
  
)

export default component.exports